import type { App } from 'vue';

// 拖动排序
// import './utils-old/nestable';

import Plugins from './plugin';
import Components from './components';
import { makeInstaller } from './make-installer';

import './assets/iconfont/iconfont.js';

// 输出组件所有配置
export * from './components/color-picker-v3';
export * from './components/background';
export * from './components/photo-list';
export * from './components/gallery';

// 输出插件
export * from './plugin';

export * from './types/index';

export * from './hooks';

// export { $createDialog } from './components-old/dialog';
// export { default as $message } from './components-old/message';

export { Plugins, Components, makeInstaller };

/**
 * 全局加载所有组件及插件
 * @param app
 */
export function install(app: App) {
  makeInstaller([...Components, ...Plugins]).install(app);
}

export default {};
